<template>
    <div id="vakSubstance" v-if="contentServiceUrlLoaded">
        <VAKHaku/>
        <VAKSubstanceTable v-bind:ykNro="ykNro" />
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Prop } from "vue-property-decorator"
    import VAKHaku from "@/components/VAKHaku.vue"
    import VAKSubstanceTable from "@/components/VAKSubstanceTable.vue"
    import ApiService from "../services/ApiService"

    @Component({
        components: {
            VAKHaku,
            VAKSubstanceTable
        }
    })
    export default class VAKSubstancePage extends Vue {
        @Prop(String) readonly ykNro!: string
        apiService: ApiService = new ApiService(this.$store.getters.baseHref)

        get contentServiceUrlLoaded(): boolean {
            return this.$store.getters.contentServiceUrl.length > 0
        }
    }
</script>
